// extracted by mini-css-extract-plugin
module.exports = {"heightSpacer":"PlanOfCare_heightSpacer__1PHku"};